module.exports = __webpack_public_path__ + "img/loading-pink.abd5845c.svg";